<template>
  <footer class="footer pb-5">
    <div style="background-color: #fafafa">
      <div class="container-fluid px-footer mb-5 py-5">
        <div class="row no-gutters">
          <!-- dynamic cols -->
          <div
            class="mt-4 col-md-6 col-lg-3 text-center text-md-left d-flex flex-column justify-content-around"
            v-for="section in sections"
            :key="section.id"
          >
            <div
              class="d-flex align-items-center mb-3 justify-content-center justify-content-sm-start"
              style="font-size: 9px"
            >
              <icon-vue
                class="mr-2 text-lilac"
                icon="circle"
                size="xs"
              ></icon-vue>
              <h5 class="font-weight-bold text-blue m-0">
                {{ section.title }}
              </h5>
            </div>
            <b-nav vertical small class="footer-nav">
              <template v-for="(link, index) in section.links">
                <b-nav-item
                  v-if="link.type !== 'external_link'"
                  link-classes="text-blue py-2"
                  :key="`link-${index}`"
                  :href="link.url"
                >
                  {{ link.title }}
                </b-nav-item>
                <a
                  class="text-blue py-2 nav-link"
                  :href="link.url"
                  :key="`link-${index}`"
                  target="_blank"
                  v-else
                >
                  {{ link.title }}</a
                >
              </template>
            </b-nav>
          </div>

          <div class="mt-4 col-md-6 col-lg-3 text-center text-md-left">
            <div
              class="d-flex align-items-center mb-3 justify-content-center justify-content-sm-start"
              style="font-size: 9px"
            >
              <icon-vue
                class="mr-2 text-green"
                icon="circle"
                size="xs"
              ></icon-vue>
              <h5 class="font-weight-bold text-blue m-0">Contact Us</h5>
            </div>
            <b-nav vertical small class="footer-nav">
              <b-nav-text
                class="py-2 d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <p class="m-0 text-green">Tel:</p>
                &nbsp;
                <p class="m-0 text-blue">0116 2211793</p></b-nav-text
              >
              <b-nav-text
                class="py-2 d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <p class="m-0 text-green">Email:</p>
                &nbsp;
                <p class="m-0 text-blue">
                  admin@leicestercarnival.co.uk
                </p></b-nav-text
              >
              <b-nav-text
                class="py-2 d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <p class="m-0 text-green">Website:</p>
                &nbsp;
                <p class="m-0 text-blue">
                  www.leicestercarnival.co.uk
                </p></b-nav-text
              >
              <!-- <b-nav-text
                class="py-2 d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <p class="m-0 text-green">Location:</p>
                &nbsp;
                <p
                  class="m-0 text-blue pointer"
                  @click="toRoute('/contact?mapRoutes=true')"
                >
                  View map
                </p>
              </b-nav-text> -->
              <b-nav-text
                class="py-2 text-green d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <!--<icon-vue icon="circle" size="xs" class="mr-2"></icon-vue>-->
                <img
                  height="16"
                  src="../../assets/svg/facebook.svg"
                  alt=""
                  class="mr-2"
                />
                <a
                  href="https://www.facebook.com/LeicesterCaribbeanCarnival"
                  target="_blank"
                  class="m-0 text-blue"
                  >Visit our facebook page</a
                ></b-nav-text
              >
            </b-nav>
          </div>
          <div
            class="mt-4 col-md-6 col-lg-3 text-center text-md-left d-flex flex-column justify-content-around"
          >
            <div
              class="d-flex align-items-center mb-3 justify-content-center justify-content-sm-start"
              style="font-size: 9px"
            >
              <icon-vue
                class="mr-2 text-blue-50"
                icon="circle"
                size="xs"
              ></icon-vue>
              <h5 class="font-weight-bold text-blue m-0">Stay upto Date</h5>
            </div>
            <b-form @submit.prevent="subscribe" class="">
              <b-form-group class="mb-3" id="grp-name">
                <b-form-input
                  id="name"
                  type="text"
                  required
                  class="border-0 btn-carnival"
                  size="sm"
                  placeholder="Full Name"
                  v-model="subForm.name"
                ></b-form-input>
              </b-form-group>
              <b-form-group class="mb-4" id="grp-email">
                <b-form-input
                  id="email"
                  type="email"
                  required
                  class="border-0 btn-carnival"
                  size="sm"
                  placeholder="Email"
                  v-model="subForm.email"
                ></b-form-input>
              </b-form-group>
              <b-button
                :disabled="saving"
                class="bg-blue-50 btn-primary btn-carnival px-4 btn-signup"
                size="sm"
                type="submit"
              >
                <span v-show="saving" class="text-white">
                  <b-spinner
                    v-if="saving"
                    style="width: 17px; height: 17px"
                    class="mr-2"
                    small
                  ></b-spinner
                  >Saving...
                </span>
                <span v-show="!saving" class="text-white">Sign Up</span>
              </b-button>
            </b-form>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid px-footer mb-3">
      <div class="mt-5 row">
        <div class="col-12">
          <flickity
            ref="footer-flickity"
            :options="options"
            v-if="sponsors.length"
          >
            <!--<div class="col-4 col-md-3 col-lg-2 cell d-flex justify-content-center"-->
            <!--:class="{'is-initial-slide': index === 0}"-->
            <!--v-for="(spons, index) in sponsors" :key="spons.id">-->
            <!--<img class="img-fluid img-slide" :src="spons.url" alt="">-->
            <!--</div>-->
            <div
              class="col-4 col-md-3 col-lg-2 cell d-flex justify-content-center"
              v-for="(brand, index) in sponsors"
              :key="brand.id"
            >
              <img class="img-fluid img-slide" :src="brand.url" alt="" />
            </div>
          </flickity>
        </div>
      </div>
      <hr class="head-line-gradient" />
      <div class="row">
        <div class="col-md-8">
          <p class="m-0 text-blue small text-center text-md-left">
            Leicester Caribbean Community Caribbean Carnival CIO, African
            Caribbean Centre, Maidstone Road, Leicester LE2 0UA.
          </p>
        </div>
        <div
          class="col-md-4 d-flex justify-content-center justify-content-lg-end align-items-center mt-2 mt-lg-0"
        >
          <p class="m-0 text-blue small text-center text-md-right">
            Handcrafted with Love
          </p>
          <a href="http://mediabeast.co.uk/"
            ><img
              :src="require('../../assets/img/footer-logo.png')"
              alt=""
              height="24"
              class="ml-3"
          /></a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import Flickity from "vue-flickity";
import AddDataHandler from "../../mixins/genericAddDataHandler";
import { dbRefs } from "../../services/firebase/init";
import { mapState } from "vuex";

export default {
  data() {
    return {
      subForm: {
        name: "",
        email: "",
      },
      options: {
        initialIndex: 0,
        groupCells: 1,
        autoPlay: 3000,
        contain: true,
        freeScroll: true,
        prevNextButtons: false,
        pageDots: false,
        cellAlign: "left",
        wrapAround: true,
      },
      fetched: false,
    };
  },
  mixins: [AddDataHandler],
  components: {
    Flickity,
  },
  methods: {
    async subscribe() {
      await this.saveData(this.dbRefs.newsRef, this.subForm);
    },
    formatLink(link) {
      const spliRoute = link.split("https://leicestercarnival.co.uk");
      console.log(spliRoute, "split route");
      return spliRoute.slice(1).join();
    },
  },
  computed: {
    ...mapState({
      sections: (state) => state.content.footerSections,
      sponsors: (state) => state.content.sponsors,
    }),
    year() {
      return new Date().getFullYear();
    },
  },
  async mounted() {
    await this.fetchCollection({
      ref: dbRefs.footerRef,
      collectionName: "footerSections",
    });
  },
};
</script>

<style lang="scss" scoped>
.cell {
  /*margin: 0 50px;*/
  /*width: 20%;*/
  height: 80px;
}

.img-slide {
  /*bottom: 0;*/
  object-fit: contain;
}

/*.container {*/
/*width: 100%;*/
/*padding-right: 15px;*/
/*padding-left: 15px;*/
/*margin-right: auto;*/
/*margin-left: auto;*/
/*}*/

.px-footer {
  padding: 0 90px;
  @media (max-width: 768px) {
    padding: 0 30px;
  }
}

.footer-nav {
  font-size: 17px !important;
  letter-spacing: -0.2px;
  color: #565887;
}
.btn-signup {
  @media (max-width: 576px) {
    height: 51px;
  }
}
</style>
